const extensions = [/.*\.jpg/, /.*\.png/, /.*\.gif/];

function imageHasExtension(imageSrc) {
  return extensions.some(e => e.test(imageSrc));
}

export default imageHasExtension;
